import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledContributorRow = styled.div`
  display: flex;
  align-items: center;
  & .contributor-name {
    margin-left: 1rem;
  }
`;

export const StyledContributorsView = styled.div`
  width: 30%;
  border: 1px solid ${getColor('catskillWhite')};
  margin-left: 1rem;
  height: 100%;
  & > header {
    background-color: ${getColor('titanWhite')};
    color: ${getColor('shuttleGray')};
    padding: 0.5rem;
    margin-bottom: 1rem;
  }
  & ${StyledContributorRow} {
    padding: 0 0.5rem;
    margin-bottom: 0.7rem;
  }
  & > main.contributor-list {
    height: 88%;
    overflow-y: scroll;
  }
`;
